import { Reducer } from 'react';
import { Actions } from '../../actions/yardList';
import { Action, YardListState } from '../../types';

const initialYardListState: YardListState = {
    searchPhrase: '',
};

const setSearchPhrase = (search: string, state: YardListState): YardListState => {
    return {
        ...state,
        searchPhrase: search,
    };
};

const yardListReducer: Reducer<YardListState, Action> = (state, action): YardListState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.UPDATE_SEARCH_PHRASE:
            newState = setSearchPhrase(action.payload, state);
            break;
    }

    return newState;
};

export { initialYardListState, yardListReducer };
